import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog'
import { Button } from '../components/ui/button'
import { useEffect, useState } from 'react'
import { Endpoints } from '@/remote/endpoints'
import { usePromiseToast } from '../hooks/toast-promisse'
import { useRemoteClientGet } from '@/configs/http-client'
import { ScrollArea } from '../components/ui/scroll-area'
import { PlanFormData } from '../validators/plan-validator'
import PlanForm from '../forms/plan-form'
import { useSearchParams } from 'react-router-dom'

type DialogProps = {
  id: number
  isOpen: boolean
  closeDialog: () => void
  updateList?: () => void
}

export function DialogEditPlan({ id, isOpen = false, closeDialog, updateList }: DialogProps) {
  const { remoteClientGet } = useRemoteClientGet();
  const { triggerToast } = usePromiseToast();
  const [isLoading, setIsLoading] = useState(false);
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<PlanFormData>();


  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await remoteClientGet(`${Endpoints.plans}/${id}?unidadeId=${params.get('unit')}`);
      setData(response?.data?.data);
    } catch (error) {
      setError('Erro ao carregar dados...');
      console.error(error);
      throw error
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      triggerToast(fetchData());
    }
  }, [isOpen, id]);


  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Plano</DialogTitle>
          <DialogDescription>Detalhes</DialogDescription>
        </DialogHeader>

        {isLoading && (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-acelerafit-green-300" />
          </div>
        )}

        {error && (
          <div className="text-red-500 p-4 text-center">
            {error}
          </div>
        )}

        {!isLoading && !error && (
          <ScrollArea className="">
            <PlanForm closeDialog={closeDialog} updateList={updateList} data={data} />
          </ScrollArea>
        )}

        <DialogFooter className="sm:justify-end">
          <Button
            type="submit"
            form="formPlan"
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Salvar
          </Button>

          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>

      </DialogContent>
    </Dialog>
  );
}